import React from 'react';
import { Helmet } from 'react-helmet-async';
import '../styles/HomeComponents/AboutUs.css'; // Make sure this path matches your project structure

const AboutUs = () => {
  return (
    <div className="about-page">
       <Helmet>
        <title>About Strawket | Our Story, Mission & Purpose</title>
        <meta 
          name="description" 
          content="Discover Strawket's journey — from a shared vision to a full academy operating system that connects passionate educators with curious learners." 
        />
        <meta 
          name="keywords" 
          content="About Strawket, Strawket story, Strawket mission, edtech platform, academy operating system, educators and learners, student platform" 
        />
        <link rel="canonical" href="https://www.strawket.com/about" />

        {/* Open Graph (Facebook, LinkedIn, etc.) */}
        <meta property="og:title" content="About Strawket | A Platform Built on Passion for Learning" />
        <meta 
          property="og:description" 
          content="Learn how Strawket was built to unburden educators, empower learners, and simplify running an academy. Real pain points. Real solutions." 
        />
        <meta property="og:url" content="https://www.strawket.com/about" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://www.strawket.com/assets/images/strawket-about-preview.png" />

        {/* Twitter Card */}
        <meta name="twitter:title" content="About Strawket | Built for Educators & Learners" />
        <meta 
          name="twitter:description" 
          content="Discover the story behind Strawket — a platform that simplifies education by connecting passionate educators with learners worldwide." 
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content="https://www.strawket.com/assets/images/strawket-about-preview.png" />
      </Helmet>
      <header className="about-header">
        <h1>About Strawket</h1>
        <p>Connecting Passionate Educators with Curious Learners</p>
      </header>

      <section className="about-section">
        <div className="container">
          <p>
            Strawket was born from the founding team’s vision of helping people follow their passion. Here is our origin story.
          </p>
          <p>
            While we were working on building an academy, we spent hundreds of hours speaking with learners and educators to understand how we can help them better. A few insights stood out as everyone kept telling us the same pain points again and again… and again!
          </p>
          <p>
            We found that Educators (or instructors or coaches or teachers) are all really passionate about teaching and what they are teaching. What they really do not like is the administrative stuff that is unfortunately essential when running a well-oiled academy. Another barrier for them was the big question of how they will get their students in the first place — aka, marketing.
          </p>
          <p>
            This was a real pain for passionate educators and many did not even start off because they were intimidated by admin and marketing so much! To us, this sounded like a big miss because there were so many learners out there who could benefit from passionate educators!
          </p>
          <p>
            In the early days, we were focused on kids and so, we spoke with many of their parents. Interestingly, we found parents asking us what else we offered! While this was validation for our model, it also told us that parents were struggling to find the right instructors for their child’s passion. They also wanted to get a simple understanding of what was being taught in class.
          </p>
          <p>
            We knew we could not do everything and wanted to build a community of micro-entrepreneurs to help us carry our vision forward.
          </p>
          <p>
            This was it! From our experience of building a successful academy and hours of conversations, was forged Strawket – a simple Operating System for an Academy.
          </p>

          <h2>Our Mission</h2>
          <ul>
            <li>Connect curious learners with world-class educators globally.</li>
            <li>Provide educators with a simple, proven way to run an academy.</li>
            <li>Empower learners to find the right educators for their passion.</li>
          </ul>

          <p>
            From day one, our goal has remained the same: ignite passion in learners, unburden educators, and foster a vibrant academy ecosystem.
          </p>

          <p><strong>Welcome to Strawket — where learning meets passion, and teaching becomes effortless.</strong></p>
        </div>
      </section>
    </div>
  );
};

export default AboutUs;
